/**
 *@ngdoc directive
 *@name cbl.finanza.mf.directive:finanzaSceltaDossier
 *@restrict E
 *@description Componente contenente la lista dei dossier disponibili su cui effettuare operazioni
 *@param {String} saldoDossierState - Stato in cui atterrare quando si seleziona un dossier
 */
(function() {
    'use strict';
    var SceltaDossierCtrl = function(
        $http,
        $scope,
        $state,
        $stateParams,
        $window,
        $q,
        CONSTANTS,
        labelSrvc,
        messaggiFctr,
        userSrvc,
        brioSrvc,
        deskSrvc,
        modalAlertSrvc
    ) {
        this.$http = $http;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$window = $window;
        this.messaggiFctr = messaggiFctr;
        $scope.msg = labelSrvc.getLabel;

        this.userSrvc = userSrvc;
        this.brioSrvc = brioSrvc;
        this.deskSrvc = deskSrvc;

        this.dossierTableData = [];
        this.anagrafica = {};
        this.spinner = {
            listaDossier: true
        };
        this.messaggiFctr.chiudiLoaderBrio();

        var self = this;

        /*
         * -------------------------------------
         * START METODI PROMISE PER SERVIZI REST
         * -------------------------------------
         */

        /**
         * @ngdoc method
         * @name promiseDossierTableData
         * @methodOf cbl.finanza.mf.directive:finanzaSceltaDossier
         * @description Effettua una chiamata http per ricevere la lista dei dossier
         * @return {Promise} - Ritorna una promise contenente i dati per popolare la lista dei dossier
         */
        this.promiseDossierTableData = function() {
            self.spinner.listaDossier = true;
            return self.$http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT +
                    CONSTANTS.REST.DOSSIER +
                    'listaDossier/' +
                    self.$stateParams.ndg
            });
        };

        this.mifidAbilitato = function() {
            return userSrvc.abilitazioni.some(function(abilitazione) {
                return (
                    abilitazione.codice.toLowerCase() ===
                    CONSTANTS.ABILITAZIONI.MIFID.toLowerCase()
                );
            });
        };
        /**
         * @ngdoc method
         * @name promiseDati
         * @methodOf cbl.finanza.mf.directive:finanzaSceltaDossier
         * @description Effettua una chiamata http per ricevere il dettaglio dell'ndg
         * @return {Promise} - Ritorna una promise contenente l'anagrafica
         */
        this.promiseAnagrafica = function() {
            return self.$http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA + 'Intestatario',
                params: {
                    ndg: self.$stateParams.ndg
                }
            });
        };

        /**
     * @ngdoc method
     * @name promiseGetAlerts
     * @methodOf cbl.finanza.mf.directive:finanzaSceltaDossier
     * @description Effettua una chiamata http per verificare se i questionari sono ok
     * @return {Promise} - Ritorna una promise contenente
     */
    this.promiseGetAlerts = function () {
        return self.$http({
          method: 'GET',
           url:CONSTANTS.CABEL_CUSTOMER
            +'customer/'+'getAlertBloccoOperativo/',
            params :{
              ndg:self.$stateParams.ndg,
              listaTipiAlertDaEscludere : 'SCADENZA_MIFID'  
            }
  
        });
      };

        /*
         * -----------------------------------
         * END METODI PROMISE PER SERVIZI REST
         * -----------------------------------
         */

        /*
         * ------------------------
         * START INIT LABEL TABELLE
         * ------------------------
         */

        /**
         * @ngdoc method
         * @name initTableLabel
         * @methodOf cbl.finanza.mf.directive:finanzaSceltaDossier
         * @description Crea le labels dei campi e ne definisce la struttura
         */
        this.initTableLabel = function() {
            self.tableLabel = [{
                    name: $scope.msg('lista.scelta.dossier.codice.dossier'),
                    field: 'codiceRapporto',
                    width: '*',
                    enableFiltering: false
                },
                {
                    name: $scope.msg('lista.scelta.dossier.categoria'),
                    field: 'categoriaDossier',
                    width: '*',
                    enableFiltering: false
                },
                {
                    name: $scope.msg('lista.scelta.dossier.tipologia.prodotto'),
                    field: 'sottoCategoriaDossier',
                    width: '*',
                    enableFiltering: false
                },
                {
                    name: $scope.msg('lista.scelta.dossier.ndg'),
                    field: 'ndgIntestatario',
                    width: '*',
                    enableFiltering: false
                },
                {
                    name: $scope.msg('lista.scelta.dossier.intestazione'),
                    field: 'intestazione',
                    width: '*',
                    enableFiltering: false
                },
                {
                    name: $scope.msg('lista.scelta.dossier.apertura'),
                    field: 'dataApertura',
                    cellFilter: 'date: "dd/MM/yyyy"',
                    width: '*',
                    enableFiltering: false
                },
                {
                    name: $scope.msg('lista.scelta.dossier.blocco'),
                    field: 'dataBlocco',
                    cellFilter: 'date: "dd/MM/yyyy"',
                    width: '*',
                    enableFiltering: false
                },
                {
                    name: $scope.msg('lista.scelta.dossier.estinzione'),
                    field: 'dataChiusura',
                    cellFilter: 'date: "dd/MM/yyyy"',
                    width: '*',
                    enableFiltering: false
                }
            ];
            if (self.mifidAbilitato()) {
                self.tableLabel.push({
                    name: $scope.msg('lista.scelta.dossier.mifid.valida'),
                    field: 'mifid',
                    width: 145,
                    enableFiltering: false,
                    cellClass: 'text-center',
                    cellTemplate: '<i class="fa fa-2x" ' +
                        " ng-class=\"{'fa-check finIGreen': !row.entity.mifid, " +
                        "'fa-exclamation-triangle finIOrange': row.entity.mifid === 'SCADUTO' || row.entity.mifid === 'PPROSSIMO_A_SCADERE', " +
                        "'fa-hourglass-half': row.entity.mifid === 'W'}\" " +
                        ' data-toggle="tooltip" title="{{row.entity.alert}}" ' +
                        '></i>'
                });
            }
            self.tableLabel.push({
                name: $scope.msg('lista.scelta.dossier.abilitato.consulenza'),
                field: 'abilitatoConsulenza',
                width: 145,
                enableFiltering: false,
                cellClass: 'text-center',
                cellTemplate: '<i class="fa fa-2x" ng-class="{\'fa-check finIGreen\': row.entity.abilitatoConsulenza === true, \'fa-close finIRed\': row.entity.abilitatoConsulenza === false}"></i>'
            });
            self.tableLabel.push({
                name: $scope.msg('lista.scelta.dossier.abilitato.collocamento'),
                field: 'abilitatoCollocamento',
                width: 160,
                enableFiltering: false,
                cellClass: 'text-center',
                cellTemplate: '<i class="fa fa-2x" ng-class="{\'fa-check finIGreen\': row.entity.abilitatoCollocamento === true, \'fa-close finIRed\': row.entity.abilitatoCollocamento === false}"></i>'
            });
            if (self.$stateParams.finServizio === '1') {
                self.tableLabel.push({
                    name: $scope.msg(
                        'lista.scelta.dossier.abilitazione.servizi.investimento'
                    ),
                    field: 'abilitaConsulenza',
                    width: 150,
                    enableFiltering: false,
                    cellClass: 'center',
                    cellTemplate: '<button class="btn btn-primary btn-sm" type="button" ng-if=" !row.entity.mifid && !grid.appScope.userSrvc.nascondiAbilitaConsulenza && !row.entity.abilitatoConsulenza && !row.entity.dataChiusura && row.entity.tipologiaProdotto !== \'GESTIONE\'" ng-click="grid.appScope.abilitaConsulenza({row: row.entity})">{{grid.appScope.msg(\'lista.scelta.dossier.abilita.consulenza\')}}</button>'
                });
            }
        };

        /*
         * ----------------------
         * END INIT LABEL TABELLE
         * ----------------------
         */

        /*
         * -----------------------
         * START METODI CONTROLLER
         * -----------------------
         */

        /**
         * @ngdoc method
         * @name checkAbilitazioni
         * @methodOf cbl.finanza.mf.directive:finanzaSceltaDossier
         * @param {Array} dossierList - Array di oggetti contenente i dati della tabella
         * @returns {Array} dossierList - Array di oggetti con aggiunte per ogni oggetto le varie abilitazioni se presenti
         * @description - Inserisce nuove properties a livello di root di ciascun oggetto nell'array per identificare le varie abilitazioni nella tabella
         */
        this.checkAbilitazioni = function(dossierList) {
            dossierList.forEach(function(dossier) {
                //    			Setto di default le variabili a false
                dossier.abilitatoConsulenza = false;
                dossier.abilitatoCollocamento = false;
                if (!!dossier.datiMifid && !!dossier.datiMifid.attivitaConsob) {
                    dossier.datiMifid.attivitaConsob.forEach(function(item) {
                        //    				Setto le properties per le varie abilitazioni presenti
                        switch (item.codice.trim()) {
                            case 'E':
                                dossier.abilitatoConsulenza = true;
                                break;
                            case 'B':
                            case 'F':
                                dossier.abilitatoCollocamento = true;
                                break;
                        }
                    });
                }
                if (self.mifidAbilitato()) {
                    dossier.mifid = 'W';
                    self.promiseMifid(dossier).then(function(res) {
                        dossier.mifid = null;
                        dossier.alert = 'Sono permesse solo operazioni di vendita\n';
                        if (res.data.result) {
                            for (var i in res.data.result) {
                                var statoMifid = res.data.result[i];
                                dossier.mifid = statoMifid.statoScadenza;
                                var nominativo = statoMifid.nominativo
                                    .replaceAll('*.*', '')
                                    .trim();
                                dossier.alert +=
                                    'Questionario ' +
                                    statoMifid.tipoQuestionario +
                                    ' in stato ' +
                                    statoMifid.statoScadenza +
                                    ' per NDG ' +
                                    statoMifid.ndg +
                                    ' ' +
                                    nominativo +
                                    '\n';
                            }
                        }
                        if (!dossier.mifid) {
                            dossier.alert = null;
                        }
                    });
                }
            });
            return dossierList;
        };

        this.promiseMifid = function(dossier) {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT +
                    CONSTANTS.REST.STRUMENTO +
                    dossier.codiceRapporto +
                    '/' +
                    self.$stateParams.ndg +
                    '/recuperaAlertScadenzaMifid'
            });
        };

        /**
         * @ngdoc method
         * @name apriPagina
         * @methodOf cbl.finanza.mf.directive:finanzaSceltaDossier
         * @description Apre la pagina interessata
         * @param {Object} row - Oggetto contenente i dati del dossier selezionato
         */
        this.apriPagina = function(row) {
            //    		Effettuo i controlli sul tipo di servizio, l'abilitazione, che non sia chiuso e non sia bloccato
            if (
                self.$stateParams.finServizio === '1' &&
                row.abilitatoConsulenza &&
                !row.dataChiusura &&
                !row.dataBlocco
            ) {
                self.$stateParams.finCodiceRapporto = row.codiceRapporto;
                self.$state.go(self.saldoDossierState, self.$stateParams);
            } else if (
                self.$stateParams.finServizio === '2' &&
                row.abilitatoCollocamento &&
                !row.dataChiusura &&
                !row.dataBlocco
            ) {
                self.$stateParams.finCodiceRapporto = row.codiceRapporto;
                self.$state.go(self.saldoDossierState, self.$stateParams);
            }
        };

        /**
         * @ngdoc method
         * @name abilitaConsulenza
         * @methodOf cbl.finanza.mf.directive:finanzaSceltaDossier
         * @description Entra nella pagina di attivazione di un dossier
         * @param {Object} row
         */
        this.abilitaConsulenza = function(row) {
            self.$stateParams.finCodiceRapporto = row.codiceRapporto;
            self.$state.go(self.abilitaConsulenzaState, self.$stateParams);
        };

        /**
         * @ngdoc method
         * @name indietro
         * @methodOf cbl.finanza.mf.directive:finanzaSceltaDossier
         * @description Ritorna alla scheda cliente
         */
        this.indietro = function() {
            if (self.deskSrvc.isDesk) {
                self.deskSrvc.popEntry();
            }
            switch (self.brioSrvc.brioVersion) {
                case 'brio2':
                case 'brio3':
                    self.$stateParams.idAnagrafica = self.anagrafica.idAnagrafica;
                    self.$state.go('schedaCliente', self.$stateParams);
                    break;
                case 'brio-xc':
                    if (window.location.pathname.indexOf('SCRIVANIAUTENTE') !== -1) {
                        self.$state.go('home.schedacliente', self.$stateParams);
                    } else {
                        var parametri = [
                            //	    				{
                            //	    					chiave: 'idAnagrafica',
                            //	    					valore: self.anagrafica.idAnagrafica
                            //	    				}
                            {
                                chiave: 'ndg',
                                valore: self.$stateParams.ndg
                            }
                        ];
                        self.brioSrvc.goTo(
                            'scrivaniautente',
                            'home.schedacliente',
                            parametri
                        );
                    }
                    break;
            }
        };

        /**
         * @ngdoc method
         * @name initPage
         * @methodOf cbl.finanza.mf.directive:finanzaSceltaDossier
         * @description Fa partire le chiamate rest per visualizzare i dettagli della pagina
         */
        this.initPage = function() {
            $q.all({
                    dati: self.promiseDossierTableData(),
                    anagrafica: self.promiseAnagrafica(),
                    label: labelSrvc.labelsPronte,
                    user: userSrvc.abilitazioniPronte
                })
                .then(
                    function(response) {
                        if (
                            self.messaggiFctr.processaResponse(response.dati) ||
                            self.messaggiFctr.processaResponse(response.anagrafica)
                        ) {
                            self.dossierTableData = [];
                            return;
                        }
                        self.initTableLabel();
                        self.dossierTableData = self.checkAbilitazioni(
                            response.dati.data.result
                        );
                        self.anagrafica = response.anagrafica.data.result[0];
                    },
                    function(reason) {
                        self.messaggiFctr.processaResponse(reason.dati);
                        self.dossierTableData = [];
                        self.anagrafica = {};
                    }
                )
                .finally(function() {
                    self.spinner.listaDossier = false;
                });
        };
        /*
         * ---------------------
         * END METODI CONTROLLER
         * ---------------------
         */

        /*
         * ----------------------------
         * START METODI INIT CONTROLLER
         * ----------------------------
         */

        this.init = function() {
            // Se sono in ScrivaniaUtente (Brio Flexcube) chiamo il freddyService per
            // aggiungere la rotta di consulenza base ai breadcrumb

            if (self.deskSrvc.isDesk) {
                labelSrvc.labelsPronte.then(function() {
                    self.deskSrvc.aggiungiEntry(
                        labelSrvc.getLabel('scelta.dossier.titolo')
                    );
                });
            }
            this.promiseGetAlerts().then(
                function (response) {
                  if (self.messaggiFctr.processaCabelAlertResponse(response)) {
                    self.spinner.listaDossier = false;
                    // modalAlertSrvc.notify({ message: 'Test', level: 'WARNING' });
                    return;
                  }
                  if (!response.data.bloccoOperativitaEffettivo) {
                    self.initPage();
                  } else {
                    self.spinner.listaDossier = false;
                  }
                },
                function (reason) {
                  self.messaggiFctr.processaResponse(reason);
                  self.spinner.listaDossier = false;
                }
            );
        };


        this.init();

        /*
         * --------------------------
         * END METODI INIT CONTROLLER
         * --------------------------
         */
    };

    SceltaDossierCtrl.$inject = [
        '$http',
        '$scope',
        '$state',
        '$stateParams',
        '$window',
        '$q',
        'FIN_CONSTANTS',
        'FinLabelSrvc',
        'FinMessaggiFctr',
        'FinUserSrvc',
        'FinBrioSrvc',
        'FinDeskSrvc',
        'modalAlertSrvc'
    ];

    var TemplateUrl = function(CONSTANTS) {
        return (
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'sceltaDossier/sceltaDossier.html'
        );
    };
    TemplateUrl.$inject = ['FIN_CONSTANTS'];

    var SceltaDossierComponent = {
        bindings: {
            saldoDossierState: '@',
            abilitaConsulenzaState: '@'
        },
        controller: SceltaDossierCtrl,
        controllerAs: 'sceltaDossierCtrl',
        templateUrl: TemplateUrl
    };

    angular
        .module('cbl.finanza.mf')
        .component('finanzaSceltaDossier', SceltaDossierComponent);
})();


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/sceltaDossier/sceltaDossier.cmpt.js
 ** module id = 14
 ** module chunks = 0 1 2
 **/